/**
 * @generated by @interxfi/j5-codegen (Plugin: NormalizedQueryPlugin) - do not edit */

import type { IxcPaymentsV1AccountNumberEvent } from '@interxfi/types';
import { schema } from 'normalizr';

export const IXC_PAYMENTS_V1_ACCOUNT_NUMBER_EVENT_ENTITY_NAME = 'ixc.payments.v1.AccountNumberEvent';
export const ixcPaymentsV1AccountNumberEventEntity = new schema.Entity<IxcPaymentsV1AccountNumberEvent>(IXC_PAYMENTS_V1_ACCOUNT_NUMBER_EVENT_ENTITY_NAME, {}, { idAttribute: (entity: IxcPaymentsV1AccountNumberEvent) => `${entity.metadata?.eventId}` });

